export default {
  namespaced: true,
  modules: {
    categories: require("./categories").default,
    channels: require("./channels").default,
    hooks: require("./hooks").default,
    recipientTypes: require("./recipientTypes").default
  }
};
